var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInsightsInactive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.75 3a.5.5 0 0 1 .5.5v16a.5.5 0 0 0 .5.5h17a.5.5 0 0 1 0 1h-17a1.5 1.5 0 0 1-1.5-1.5v-16a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.959 12.651a1 1 0 0 1-1.102.265l-2.955-1.137-1.781 1.918a1 1 0 0 1-1.046.27l-1.825-.602V16.5h11v-6.395zm3.291-2.546c0-.916-1.13-1.35-1.743-.668l-2.292 2.545-3.586-1.38-2.241 2.415-1.825-.602a1 1 0 0 0-1.313.95V17.5h13zm.128-4.932a.5.5 0 0 1-.05.705l-4 3.467a.5.5 0 0 1-.563.063l-3.18-1.696L8.346 9.86a.5.5 0 0 1-.433.131l-3-.533a.5.5 0 1 1 .175-.985l2.75.49 2.316-2.225a.5.5 0 0 1 .581-.08l3.197 1.705 3.74-3.242a.5.5 0 0 1 .706.05Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInsightsInactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/insights-inactive.927a6687.svg";